module.exports = __webpack_public_path__ + "static/media/project-image-7.a2707fe0.jpg";